import React, { useState, useEffect } from "react";
import SideDrawer from "./SideDrawer";
import { getInitials } from "../utils/headerUtils";


interface UserProfileProps {
  userData: any;
  knowledgeHubUrl: string;
  showDrawer?: boolean;
}

const UserProfile: React.FC<UserProfileProps> = ({ userData, knowledgeHubUrl, showDrawer }) => {
  const [imgError, setImgError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const renderProfileImage = () => {
    if (userData?.["Recruiter Image"] && !imgError) {
      return (
        <img
          src={userData?.["Recruiter Image"]}
          alt="profile"
          className="rec_profile_img"
          width={36}
          height={36}
          onError={() => setImgError(true)}
        />
      );
    }

    return (
      <span className="rec_header_rs_profileDpPlaceholder">
        {getInitials(userData?.name || userData?.username)}
      </span>
    );
  };

  // lock/unlock body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Avatar + Name */}
      <div className="rec_header_up_container" onClick={() => setIsOpen(true)}>
        <div className="rec_header_up_img_wrapper">{renderProfileImage()}</div>

        <div className="rec_header_up_txt">
          <span style={{fontSize: "12px", color: "#59566C"}}>Hello,</span>
          <span className="rec_header_up_txt_overflow">
            {userData?.name ? userData.name : userData?.username}
          </span>
        </div>
      </div>

      {/* Drawer */}
      {(showDrawer || isOpen) && <SideDrawer
          renderProfileImage={renderProfileImage}
          isOpen={isOpen}
          handleClose={handleClose}
          userData={userData}
          knowledgeHubUrl={knowledgeHubUrl}
        />}
    </>
  );
};

export default React.memo(UserProfile);
